import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Smartphone } from 'lucide-react';

export interface Session {
  id: string;
  name: string;
  device: string;
  lastActive: string;
  isCurrent?: boolean;
}

interface SessionManagementProps {
  sessions?: Session[];
  onRevokeSession?: (sessionId: string) => void;
  onSignOutAll?: () => void;
}

const SessionManagement = ({
  sessions = [
    {
      id: 'current',
      name: 'Current Session',
      device: 'Chrome on Windows • Active now',
      lastActive: 'now',
      isCurrent: true,
    },
    {
      id: 'mobile',
      name: 'Mobile App',
      device: 'iOS • 2 hours ago',
      lastActive: '2 hours ago',
      isCurrent: false,
    },
  ],
  onRevokeSession,
  onSignOutAll,
}: SessionManagementProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center space-x-2 text-base sm:text-lg">
          <Smartphone className="h-5 w-5 flex-shrink-0" />
          <span>Session Management</span>
        </CardTitle>
        <CardDescription>Manage your active sessions</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-3">
          {sessions.map(session => (
            <div
              key={session.id}
              className="flex items-center justify-between p-3 border rounded-lg gap-2"
            >
              <div className="min-w-0">
                <p className="text-sm font-medium truncate">{session.name}</p>
                <p className="text-xs text-muted-foreground">
                  {session.device}
                </p>
              </div>
              {session.isCurrent ? (
                <Badge variant="default">Current</Badge>
              ) : (
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => onRevokeSession?.(session.id)}
                >
                  Revoke
                </Button>
              )}
            </div>
          ))}
        </div>
        <Button
          variant="destructive"
          size="sm"
          className="w-full"
          onClick={onSignOutAll}
        >
          Sign Out All Other Sessions
        </Button>
      </CardContent>
    </Card>
  );
};

export default SessionManagement;
